module.exports = __webpack_public_path__ + "img/bg_pattern-60.1c65fd28.png";